import React from 'react';



class Loading extends React.PureComponent {
	render() {
		if(this.props.pastDelay) {
			return <div>Loading...</div>
		}

		return null;
	}

}



export default Loading;